import * as React from "react";

export interface MobilePageSectionProps {
    id: string;
    label?: string;
    children: React.ReactNode;
    isDirty?: boolean;
    count?: number;
    info?: boolean;
    errors?: boolean;
}

export const MobilePageSection = (props: MobilePageSectionProps) => {
    const { children, id } = props;
    return <>{children}</>;
};
